import { DataQueryKey, UseDataQueryKey } from '../../../hooks/useDataQuery/dataQuery.types';

export const getSalesOpportunityQueryKey = (customerId: string): UseDataQueryKey => [
  DataQueryKey.ORDER_BOOK_SALES_OPPORTUNITIES,
  customerId,
];

export const getSalesOpportunityCategoriesQueryKey = (
  salesOpportunityId: string,
): UseDataQueryKey => [
  DataQueryKey.ORDER_BOOK_SALES_OPPORTUNITIES,
  DataQueryKey.ORDER_BOOK_SALES_OPPORTUNITIES_CATEGORIES,
  salesOpportunityId,
];

export const getSalesOpportunityConversionQueryKey = (customerId: string): UseDataQueryKey => [
  DataQueryKey.ORDER_BOOK_SALES_OPPORTUNITIES,
  DataQueryKey.ORDER_BOOK_SALES_OPPORTUNITIES_CONVERSIONS,
  customerId,
];
